/** @example
 * *<apt-attached-files attachments="$ctrl.attachments">
 * *<i class="attachment-icon fa fa-paperclip" aria-hidden="true"></i>
 * *</apt-attached-files>
 */

class AptAttachedFilesCtrl {
  static bindings = {
    attachments: '<',
    listView: '<'
  };

  attachments;
  listView;
}

export const AptAttachedFilesComponent = {
  template: require('./aptAttachedFiles.component.html'),
  controller: AptAttachedFilesCtrl,
  transclude: true,
  bindings: AptAttachedFilesCtrl.bindings
};
